export default __webpack_public_path__ + "static/media/multiple_choice_colour.376bc9aa.svg";